import { getSupportedDayjsLocale } from "@whatslly/commons/browserUtils";

export function getDateFormatString(customLocale?: string) {
  const locale = getSupportedDayjsLocale(customLocale);
  const formatObj = new Intl.DateTimeFormat(locale).formatToParts(new Date());

  return formatObj
    .map((obj) => {
      switch (obj.type) {
        case "day":
          return "DD";
        case "month":
          return "MM";
        case "year":
          return "YYYY";
        default:
          return obj.value;
      }
    })
    .join("")
    .replaceAll(".", "/");
}
